import TrainingGrid from './TrainingGrid';

export default TrainingGrid;
